<script lang="ts">
    import { translation } from "../../../../stores.js";
    import ButtonControl from "../../ButtonControl.svelte";

    export let paused: boolean;
    export let muted: boolean;
    export let audioEnabled: boolean;

    export let isScreenSharing: boolean;

    export let onPause: () => void;
    export let onResume: () => void;
    export let onMute: () => void;
    export let onUnmute: () => void;
    export let onScreenShare: () => void;
    export let onHangup: () => void;

    export let videoPauseOrigin: "self" | "conseiller";
    export let audioMuteOrigin: "self" | "conseiller";

    const canResume = videoPauseOrigin !== "conseiller";
    const canUnmute = audioMuteOrigin !== "conseiller";
</script>

<ButtonControl
    btnClass={isScreenSharing ? "red" : "blue"}
    onClick={onScreenShare}
    icon="fa fa-desktop"
    title={isScreenSharing ? "Stop Screensharing" : "Start Screensharing"}
/>

<ButtonControl
    btnClass={paused ? (canResume ? "green" : "gray") : "gray"}
    onClick={() => {
        if (paused && canResume) onResume();
        else if (!paused) onPause();
    }}
    icon={paused ? "fa fa-play" : "fa fa-pause"}
    title={paused
        ? canResume
            ? translation.camera.resumeButton
            : translation.alert.cameraPausedAdvisor
        : translation.camera.pauseButton} 
    disabled={paused && !canResume}
/>

{#if audioEnabled}
    <ButtonControl
        btnClass={muted ? "green" : "gray"}
        onClick={() => {
            if (muted && canUnmute) onUnmute();
            else if (!muted) onMute();
        }}
        icon={muted ? "fa fa-microphone-slash" : "fa fa-microphone"}
        title={muted
            ? canUnmute
                ? translation.camera.resumeMicButton
                : translation.alert.cameraMutedAdvisor
            : translation.camera.micButton}
        disabled={muted && !canUnmute}
    />
{/if}
<ButtonControl
    btnClass="red"
    onClick={onHangup}
    icon="fa fa-stop"
    title="Hangup"
/>